<div class="card card-custom">
  <div *ngIf="showHeader" class="card-header align-items-center">
    <div class="card-title">
      <h3 class="card-label">Task History List</h3>
    </div>
    <button
      mat-raised-button
      [matTooltip]="'GLOBAL.CLOSE' | translate"
      class="btn btn-icon btn-light"
      (click)="closeDialog($event)"
    >
      <span
        inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
        class="svg-icon svg-icon-lg"
      ></span>
    </button>
  </div>
  <div class="card-body">
    <div *ngIf="loadingHistory" class="d-flex flex-center h-100">
      <mat-spinner [diameter]="75" [strokeWidth]="5"></mat-spinner>
    </div>
    <div *ngIf="!loadingHistory" class="d-flex flex-column h-100">
      <div class="history-list-row history-list-header">
        <div style="width: 160px" class="px-2">Property</div>
        <div style="width: 200px" class="flex-grow-1 px-2">Old</div>
        <div style="width: 200px" class="flex-grow-1 px-2">New</div>
        <div style="width: 160px" class="px-2">Changed By</div>
        <div style="width: 160px" class="px-2">Date & Time</div>
      </div>
      <div *ngIf="!history.length" class="flex-grow-1 d-flex flex-column flex-center font-size-lg">
        <span class="font-weight-bolder">No Actions!</span>
        <span>Your actions will be displayed here.</span>
      </div>
      <div
        *ngIf="history.length"
        class="flex-grow-1 scroll"
        [perfectScrollbar]="{ wheelPropagation: false }"
      >
        <div *ngFor="let record of history" class="history-list-row hoverable">
          <div style="width: 160px" class="px-2">{{ record.property }}</div>
          <div style="width: 200px" class="flex-grow-1 text-lines-2 px-2">{{ record.old }}</div>
          <div style="width: 200px" class="flex-grow-1 text-lines-2 px-2">{{ record.new }}</div>
          <div style="width: 160px" class="px-2">{{ record.changedBy }}</div>
          <div style="width: 160px" class="px-2">
            {{ record.dateTime | date : 'MMM dd, yyyy hh:mm a' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
